import OAuth from "@/api/OAuth";
import makeOAuthToken from "./makeOAuthToken";

import axios from "axios";

class ClientToken {
  accessToken = null;

  constructor(clientId, scope) {
    this.clientId = clientId;
    this.scope = scope;
    const accessToken = window.localStorage.getItem(
      `${this.clientId}client_access_token`
    );
    if (accessToken) this.accessToken = accessToken;

    setInterval(() => {
      this.request();
    }, 15 * 60 * 1000); // 15 min

    axios.interceptors.request.use(request => {
      // set Authorization headers if not set manually (by token or user-auth requests)
      if (!request.needUserAuth && !request.headers.Authorization) {
        request.headers.Authorization = `Bearer ${this.accessToken}`;
      }
      return request;
    });
  }

  async request() {
    const oauthToken = makeOAuthToken(this.clientId);
    const response = await OAuth.getClientToken(oauthToken, this.scope);
    const accessToken = response.access_token;
    this.accessToken = accessToken;
    window.localStorage.setItem(
      `${this.clientId}client_access_token`,
      accessToken
    );
  }

  async get() {
    if (this.accessToken) return this.accessToken;

    await this.request();
    return this.accessToken;
  }
}

export default ClientToken;
